(() => {
  const initializedAttribute = 'data-wa-tabs-initialized';
  const smoothScrollInitializedAttribute = 'data-wa-smooth-scroll-initialized';

  function activateTab(tabGroup, nextTab, moveFocus = false) {
    const tabs = Array.from(tabGroup.querySelectorAll('[data-wa-tab]'));
    const panels = Array.from(tabGroup.querySelectorAll('[data-wa-panel]'));

    if (!tabs.includes(nextTab)) return;

    tabs.forEach((tab) => {
      const isActive = tab === nextTab;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
      tab.tabIndex = isActive ? 0 : -1;
    });

    panels.forEach((panel) => {
      panel.hidden = panel.id !== nextTab.getAttribute('aria-controls');
    });

    const seeAllLink = tabGroup.querySelector('[data-wa-see-all]');
    if (seeAllLink && nextTab.dataset.waUrl) {
      seeAllLink.href = nextTab.dataset.waUrl;
    }

    if (moveFocus) nextTab.focus();
  }

  function handleTabKeydown(event, tabGroup, currentTab) {
    const tabs = Array.from(tabGroup.querySelectorAll('[data-wa-tab]'));
    const currentIndex = tabs.indexOf(currentTab);
    let nextIndex = currentIndex;

    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = tabs.length - 1;
    if (nextIndex === currentIndex) return;

    event.preventDefault();
    activateTab(tabGroup, tabs[nextIndex], true);
  }

  function initializeTabGroup(tabGroup) {
    if (tabGroup.hasAttribute(initializedAttribute)) return;
    tabGroup.setAttribute(initializedAttribute, 'true');

    const tabs = Array.from(tabGroup.querySelectorAll('[data-wa-tab]'));
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activateTab(tabGroup, tab));
      tab.addEventListener('keydown', (event) => handleTabKeydown(event, tabGroup, tab));
    });

    const selectedTab = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0];
    if (selectedTab) activateTab(tabGroup, selectedTab);
  }

  function initializeSmoothScroll(link) {
    if (link.hasAttribute(smoothScrollInitializedAttribute)) return;
    link.setAttribute(smoothScrollInitializedAttribute, 'true');

    link.addEventListener('click', (event) => {
      const hash = link.getAttribute('href');
      if (!hash?.startsWith('#')) return;

      const target = document.getElementById(hash.slice(1));
      if (!target) return;

      event.preventDefault();
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      window.history.pushState(null, '', hash);
    });
  }

  function initializeLanding(root = document) {
    root.querySelectorAll('[data-wa-tabs]').forEach(initializeTabGroup);
    root.querySelectorAll('.wa-hero__scroll[href^="#"]').forEach(initializeSmoothScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeLanding());
  } else {
    initializeLanding();
  }

  document.addEventListener('shopify:section:load', (event) => initializeLanding(event.target));
})();
